import { Formik } from "formik"
import { Form, Modal, Pagination, Table } from "react-bootstrap"
import { InfoCard2 } from "../../../widgets/components/UI/InfoCard2"
import { useIntl } from "react-intl"
import TextInput from "../../../widgets/components/Input/TextInput"
import { useEffect, useState } from "react"
// import { useThemeMode } from "../../../../../_metronic/partials"
import { useLocation, useNavigate } from "react-router-dom"
import { DisplayImage } from "../../../widgets/components/General/DisplayImage"
import * as Yup from 'yup'
import { createParticipants, deleteParticipants, getIndividuals, getParticipants, updateMeetingParticipant } from "../../core/_requests"
import { toast } from "react-toastify"
import deleteIcon from '../../../../../media/stakeholders/ic-delete.svg'
import addIcon from '../../../../../media/shared-access/ic-add.svg'
import removeIcon from '../../../../../media/shared-access/cancel.svg'
import { RankingInfo, rankItem } from '@tanstack/match-sorter-utils'
import {
    ColumnDef,
    ColumnFiltersState,
    FilterFn,
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import React from "react"
import { participantType } from "../../core/_constants"
import { useAuth } from "../../../auth"
import NoDataPage from "../../../widgets/components/NoDataPage"
import SkeletonRow from "../../../digital-signing/components/SkeletonRow"
import { toTitleCase } from "../../core/_util"
import { DeleteParticipantConfirmationModal } from "../CancelConfimrationModal"
import TagManager from "react-gtm-module"
import { GTMEvent } from "../../../../hooks/gtmHelpers"
import { profileData } from "../../../profile/core/_requests"
import { useThemeMode } from "../../../../../_metronic/partials"
import brandingConfig from "../../../../../config/brandingConfig"
export default function AddParticipants({ isActive, setIsActive, meetingId, participantData, meetingType }: any) {
    const { formatMessage } = useIntl()
    const { mode } = useThemeMode()
    const { companyId, currentUser } = useAuth()
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [participantsData, setParticipantsData] = useState<any>([])
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [cancelLoading, setCancelLoading] = useState(false)
    const [id, setId] = useState('')
    const [email, setEmail] = useState('')
    const [pagination, setPagination] = useState<{
        currentPage: number
        pageSize: number
        totalCount: number
        nextPage: number
        prevPage: number | null
        totalPages: number
    }>({
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        nextPage: 0,
        prevPage: null,
        totalPages: 0,
    })
    const handleSubmit = async () => {
        if (guestData.length === 0) {
            toast.error(formatMessage({ id: 'Please add at least one guest' }))
        }
        let updatedGuestData: any
        if (guestData.length) {
            updatedGuestData = guestData.map(guest => ({
                ...guest,
                isGuest: true,
            }));
        }
        const payload: any = {};
        payload['participants'] = updatedGuestData

        try {
            setLoading(true)
            const {
                data: { success, error },
            } = await createParticipants(payload, meetingId, companyId)
            if (success) {
                toast.success(formatMessage({ id: 'Participants added successfully.' }))
                setGuestData([])
                setIsActive(false)
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantAddedSuccessful,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_details: payload,

                        },
                    },
                })
            }
            else {
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantAddedSuccessful,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_details: payload,
                            error: error[0]
                        },
                    },
                })
            }
        } catch (e) {
            TagManager.dataLayer({
                dataLayer: {
                    event: GTMEvent.ParticipantAddedFailed,
                    action: 'normal',
                    metadata: {
                        company_id: companyId,
                        user_id: currentUser?.userId,
                        email: currentUser?.email,
                        participant_details: payload,
                        error: e
                    },
                },
            })
        } finally { setLoading(false) }
    }
    const userSchema = Yup.object().shape({
        guestEmail: Yup.string().email('Invalid email').required('email is required'),
        guestName: Yup.string().required('the name is required'),
        type: Yup.string(),
        shareholderType: Yup.string()
    })

    const initialValues = {
        guestName: '',
        guestEmail: '',
        type: 'Participant',
        shareholderType: ''
    }
    const [guestData, setGuestData] = useState<any[]>([])
    const handleGuestSubmit = (values: any, resetForm: any) => {
        const guest = {
            name: toTitleCase(values.guestName),
            email: values.guestEmail,
            type: values.type || 'Participant'
        }
        const isPresent = guestData?.find((guests: any) => { return guests.email === guest.email })
        const isPresentAsShareHolders = shareholdersData?.find((guests: any) => { return guests.email === guest.email })
        const participants = participantData.length > 0 && participantData?.find((guests: any) => { return guests.email === guest.email })

        if (!isPresent && !isPresentAsShareHolders && !participants) {
            setGuestData((prev: any) => { return [...prev, guest] })
            handleGuestPage()
            resetForm();
        }
        if (isPresent)
            toast.error(formatMessage({ id: 'The email has already been added as a guest.' }))
        if (participants)
            toast.error(formatMessage({ id: 'The user has already been added as a guest.' }))
        if (isPresentAsShareHolders)
            toast.error(formatMessage({ id: 'The user is already a shareholder.' }))
    }
    const updateGuestType = (email: string, newType: string) => {
        setGuestData((prevGuests) => {
            const updatedGuests = prevGuests.map((guest) => {
                if (guest.email === email) {
                    return { ...guest, type: newType };
                }
                return guest;
            });
            return updatedGuests;
        });
    };
    const removeGuest = () => {
        setCancelLoading(true)
        setGuestData((prev: any) => {
            const updatedArray = (Array.isArray(prev) ? prev : []).filter((data: any) => data.email !== email);
            return updatedArray;
        });
        handleGuestPage()
        setCancelLoading(false)
        setShowCancelModal(false)
        setEmail('')
    }
    const handleGuestPage = () => {
        setPagination((prev) => ({ ...prev, totalCount: guestData.length, totalPages: Math.ceil(guestData.length / prev.pageSize) }))
    }
    useEffect(() => {
        handleGuestPage();
    }, [guestData]);// eslint-disable-line react-hooks/exhaustive-deps
    const [shareholdersData, setShareholdersData] = useState<any[]>([])
    const [individualsData, setIndividualsData] = useState<any[]>([])
    const [tab, setTab] = useState(1)
    const [updateParticipantList, setUpdateParticipantList] = useState<any[]>([])
    const [updateParticipantList1, setUpdateParticipantList1] = useState<any[]>([])
    const options = [
        { title: formatMessage({ id: 'Add From Directory' }), subTitle: formatMessage({ id: 'Add meeting attendees from directory' }) },
        { title: formatMessage({ id: 'Add Guests' }), subTitle: formatMessage({ id: 'Invite external guests for the meeting' }) },
        { title: formatMessage({ id: 'Added Participants' }), subTitle: formatMessage({ id: 'Manage meeting participants and guests' }) },
    ]

    const handleTabChange = (index: number) => {
        setTab(index + 1)
        navigate(`${location.pathname}?tab=${options[index].title.toLowerCase()}${meetingId ? `&meetingId=${meetingId}` : ''}`)
    }

    const getIndividualParticipant = async () => {
        try {
            setIsLoading(true)
            const {
                data: { success, data },
            } = await getIndividuals(companyId, false, pagination.currentPage,
                pagination.pageSize)
            if (success) {
                setPagination((prev) => ({
                    ...prev,
                    currentPage: data.pagination?.currentPage,
                    pageSize: data.pagination?.pageSize,
                    totalCount: data.pagination?.totalRecords,
                    nextPage: data.pagination?.nextPage,
                    prevPage: data.pagination?.prevPage,
                    totalPages: data.pagination?.totalPages,
                }))
                const responseData = data.individualList.map((item: any) => {
                    let name = item.firstName + ' ' + item.lastName;
                    const matchingIndividual = individualsData.find(
                        (individual: any) => individual.individualId === item.individualId
                    );
                    const isNotEditIndividual = participantData.find(
                        (individual: any) => individual.stakeholderIndividualId === item.individualId
                    );

                    return {
                        ...item,
                        checked: matchingIndividual || isNotEditIndividual ? true : false,
                        isEdit: isNotEditIndividual ? true : false,
                        name
                    };
                });
                setShareholdersData(
                    responseData.map((item: any) => {
                        const updatedItem = updateParticipantList1.find(
                            (list: any) => list.participantId === item.individualId
                        )
                        return updatedItem ? { ...item, type: updatedItem.value } : item;
                    })
                );
            }
        } catch (err) {
            console.log(err)
        } finally {
            setIsLoading(false)
        }
    }
    const [checkedAll, setCheckedAll] = useState<boolean>(false)
    const [checked, setChecked] = useState({ index: '', value: false })
    const handleCheckAll = async (value: boolean) => {
        const updatedParticipants = shareholdersData.map((participant: any) => ({
            ...participant,
            type: 'Participant',
            checked: value
        }));
        setShareholdersData((prev: any) =>
            prev.map((participant: any) => ({
                ...participant,
                checked: value,
            }))
        );
        if (value) {
            setIndividualsData(updatedParticipants);
        } else {
            setIndividualsData([]);
        }
    };
    useEffect(() => {
        handleCheckAll(checkedAll)
    }, [checkedAll])// eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        handleCheck(checked?.index, checked.value)
    }, [checked])// eslint-disable-line react-hooks/exhaustive-deps
    const handleCheck = (index: string, value: boolean) => {
        if (value) {
            const updatedParticipants = shareholdersData.filter(
                (participant) => participant.individualId === index
            );
            setIndividualsData((prev: any) => [
                ...prev,
                ...updatedParticipants.map((participant) => ({
                    ...participant,
                    type: 'Participant',
                })),
            ]);
            setShareholdersData((prev: any) => prev.map((participant: any) =>
                participant.individualId === index
                    ? { ...participant, checked: true }
                    : participant
            ));
        } else {
            // Remove the participant from individualsData if unchecked
            setIndividualsData((prev: any) => {
                const updatedArray = (Array.isArray(prev) ? prev : []).filter(
                    (data: any) => data.individualId !== index
                );
                return updatedArray;
            });
            setShareholdersData((prev: any) => prev.map((participant: any) =>
                participant.individualId === index
                    ? { ...participant, checked: false }
                    : participant
            ));
        }
    };


    const updateIndividualType = (index: string, newType: string) => {
        setIndividualsData((individualParticipant) => {
            const updateIndividualParticipant = individualParticipant.map((participant: any) => {
                if (participant.individualId === index) {
                    return { ...participant, type: newType };
                }
                return participant;
            });
            return updateIndividualParticipant;
        });
        setShareholdersData((shareholders: any[]) => {
            const updatedShareholders = shareholders.map((shareholder: any) => {
                if (shareholder.individualId === index) {
                    return { ...shareholder, type: newType };
                }
                return shareholder;
            });
            return updatedShareholders;
        });
    };
    const getMeetingParticipant = async () => {
        try {
            setIsLoading(true)
            const {
                data: { success, data },
            } = await getParticipants(meetingId, false, pagination.currentPage,
                pagination.pageSize)
            if (success) {
                setPagination((prev) => ({
                    ...prev,
                    currentPage: data.pagination?.currentPage,
                    pageSize: data.pagination?.pageSize,
                    totalCount: data.pagination?.totalRecords,
                    nextPage: data.pagination?.nextPage,
                    prevPage: data.pagination?.prevPage,
                    totalPages: data.pagination?.totalPages,
                }))

                setParticipantsData(
                    data.data.map((item: any) => {
                        const updatedItem = updateParticipantList.find(
                            (list: any) => list.participantId === item.meetingParticipantId
                        )
                        return updatedItem ? { ...item, type: updatedItem.value } : item;
                    })
                );

            }
        } catch (err) {
            console.log(err)
        } finally {
            setIsLoading(false)
        }
    }
    const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
        const itemRank = rankItem(row.getValue(columnId), value)
        addMeta({ itemRank })
        return itemRank.passed
    }
    const removeParticipant = async () => {
        setCancelLoading(true)
        try {
            const {
                data: { success, error },
            } = await deleteParticipants(id)
            if (success) {
                getMeetingParticipant()
                toast.success(formatMessage({ id: 'Participant removed successfully.' }))
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantDeletedSuccessful,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_id: id,

                        },
                    },
                })
            } else {
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantDeleteFailed,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_id: id,
                            error: error[0]
                        },
                    },
                })
            }
        } catch (err) {
            TagManager.dataLayer({
                dataLayer: {
                    event: GTMEvent.ParticipantDeleteFailed,
                    action: 'normal',
                    metadata: {
                        company_id: companyId,
                        user_id: currentUser?.userId,
                        email: currentUser?.email,
                        participant_id: id,
                        error: err
                    },
                },
            })
        } finally {
            setCancelLoading(false)
            setShowCancelModal(false)
            setId('')
        }
    }


    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
    // const [selectedIndex, setSelectedIndex] = useState<number | undefined>()
    const [globalFilter, setGlobalFilter] = useState('')
    const multiFieldGlobalFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
        const emailMatch = rankItem(row.original.email, value)
        const nameMatch = rankItem(`${row.original.name}`, value)

        // Determine which match to use based on rank comparison or other logic
        let bestMatch: RankingInfo | undefined
        if (emailMatch.passed && nameMatch.passed) {
            bestMatch = emailMatch.rank < nameMatch.rank ? emailMatch : nameMatch
        } else if (emailMatch.passed) {
            bestMatch = emailMatch
        } else if (nameMatch.passed) {
            bestMatch = nameMatch
        }

        // Only call addMeta if a best match is found
        if (bestMatch) {
            addMeta({ itemRank: bestMatch })
        }

        // Return whether the search term passed in either field
        return !!bestMatch
    }
    const [imgName, setImgName] = useState()
    useEffect(() => {
        const getProfileInfo = async () => {
            try {
                if (companyId) {
                    const {
                        data: { success, data },
                    } = await profileData(companyId)
                    if (success) {
                        setImgName(data.profileImage)
                    }
                }
            } catch (err) {
                console.log(err)
            }
        }
        getProfileInfo()
    }, [companyId])
    const columns = React.useMemo<ColumnDef<any, any>[]>(() => {
        const baseColumns: ColumnDef<any, any>[] = [
            {
                accessorKey: 'name',
                id: 'Participant Name',
                header: 'Participant Name',
                cell: (info) => {
                    const { name, email } = info.row.original; // Destructured for readability
                    return (
                        <div className='d-flex align-items-center gap-2'>
                            <DisplayImage
                                imgName={info.row?.original?.profileImage?.name || (email === currentUser?.email && imgName) || 'dummy'}
                                alt='profile'
                                fit='cover'
                                className='rounded-circle'
                                width={32}
                                height={32}
                            />
                            <p className='mb-0 font-size-13'>{name}</p>
                        </div>
                    );
                },
                filterFn: 'includesString',
            },
            {
                accessorKey: 'email',
                id: 'Email Id',
                header: 'Email Id',
                cell: (info) => {
                    const { email } = info.row.original;
                    return <div className='px-3 pt-2'>{email}</div>;
                },
                filterFn: 'includesString',
            },
            {
                accessorKey: 'type',
                id: 'Type',
                header: 'Type',
                cell: (info) => {
                    const { type, email, meetingParticipantId, isGuest, isEdit } = info.row.original;
                    return (
                        <div className='d-flex gap-2 w-100 align-items-center justify-content-start'>
                            <Form.Select value={type} className='px-4' onChange={(e) => {
                                if (tab === 1) {
                                    updateIndividualType(info.row.original.individualId, e.target.value)
                                    setUpdateParticipantList1((prev) => {
                                        // Find the index of the participant if it exists
                                        const existingParticipantIndex = prev.findIndex(
                                            (p) => p.participantId === info.row.original.individualId
                                        );

                                        if (existingParticipantIndex !== -1) {
                                            // Update existing participant's value in the array
                                            const updatedParticipants = [...prev];
                                            updatedParticipants[existingParticipantIndex] = {
                                                ...updatedParticipants[existingParticipantIndex],
                                                value: e.target.value,
                                            };
                                            return updatedParticipants;
                                        } else {
                                            // Add new participant if they don't already exist
                                            return [
                                                ...prev,
                                                { participantId: info.row.original.individualId, value: e.target.value },
                                            ];
                                        }
                                    });

                                    setParticipantsData((prev: any) =>
                                        prev.map((data: any) =>
                                            data.meetingParticipantId === meetingParticipantId
                                                ? { ...data, type: e.target.value }
                                                : data
                                        )
                                    );
                                }
                                if (tab === 2) {
                                    updateGuestType(email, e.target.value)
                                }
                                if (tab === 3) {
                                    setUpdateParticipantList((prev) => {
                                        // Find the index of the participant if it exists
                                        const existingParticipantIndex = prev.findIndex(
                                            (p) => p.participantId === meetingParticipantId
                                        );

                                        if (existingParticipantIndex !== -1) {
                                            // Update existing participant's value in the array
                                            const updatedParticipants = [...prev];
                                            updatedParticipants[existingParticipantIndex] = {
                                                ...updatedParticipants[existingParticipantIndex],
                                                value: e.target.value,
                                            };
                                            return updatedParticipants;
                                        } else {
                                            // Add new participant if they don't already exist
                                            return [
                                                ...prev,
                                                { participantId: meetingParticipantId, value: e.target.value },
                                            ];
                                        }
                                    });

                                    setParticipantsData((prev: any) =>
                                        prev.map((data: any) =>
                                            data.meetingParticipantId === meetingParticipantId
                                                ? { ...data, type: e.target.value }
                                                : data
                                        )
                                    );

                                    // updateParticipant(meetingParticipantId, e.target.value)
                                }
                            }}>
                                {participantType.map((data: any) => {
                                    if (tab === 2 && data.value !== 'Organizer') {
                                        return (
                                            <option key={data.value} value={data.value}>
                                                {data.name}
                                            </option>
                                        );
                                    }

                                    if (tab !== 2) {
                                        return (
                                            <option key={data.value} value={data.value} selected={tab === 1 && data.value === 'Participant'} disabled={(isGuest && data.value === 'Organizer') || isEdit}>
                                                {data.name}
                                            </option>
                                        );
                                    }

                                    return null;
                                })}

                            </Form.Select>
                        </div>
                    );
                },
                filterFn: 'includesString',
            },
            {
                id: 'actions',
                header: 'Actions',
                cell: ({ row }) => {
                    const { meetingParticipantId, email, checked, isEdit, type } = row.original;
                    return (
                        <div className='d-flex justify-content-between ms-4 pt-3 dropdown-container'>
                            {type === 'Organizer' && email === currentUser?.email && tab === 3 ? '' : !checked && !isEdit && tab === 1
                                ?
                                <button
                                    className='btn btn-primary p-0 m-0'
                                    onClick={(e) => {
                                        row.toggleSelected();
                                        setChecked({ index: row.original.individualId, value: true });
                                    }}
                                    type="button"
                                >
                                    <img src={addIcon} alt='Add' />
                                </button>
                                : <button
                                    className={`btn ${checked && tab === 1 ? '' : 'btn-secondary'} p-0 m-0`}
                                    onClick={(e) => {
                                        if (tab === 1) {
                                            row.toggleSelected();
                                            setChecked({ index: row.original.individualId, value: false });
                                        }
                                        else if (tab === 2) {
                                            setShowCancelModal(true)
                                            setEmail(email)
                                        }
                                        else {
                                            setShowCancelModal(true)
                                            setId(meetingParticipantId)
                                        }
                                    }}
                                    type="button"
                                    disabled={isEdit}
                                >
                                    {tab === 1 ?
                                        <img src={removeIcon} alt='Remove' /> :
                                        <img src={deleteIcon} alt='Delete' />}
                                </button>}
                        </div>
                    );
                },
            },
        ];
        if (tab === 1) {
            baseColumns.splice(1, 0, {
                accessorKey: 'designation',
                id: 'Designation',
                header: 'Designation',
                cell: (info) => {
                    return <div className='px-3 pt-2'>Shareholder</div>;
                },
                filterFn: 'includesString',
            });
            baseColumns.splice(0, 0,
                {
                    id: 'select',
                    header: ({ table }) => (
                        <input
                            type="checkbox"
                            checked={checkedAll}
                            onChange={(e) => {
                                const isChecked = e.target.checked;
                                table.toggleAllRowsSelected(isChecked);
                                setCheckedAll(isChecked)
                            }}
                        />
                    ),
                    cell: ({ row }) => (
                        <input
                            type="checkbox"
                            className="mt-3"
                            checked={row.original.checked || row.original.isEdit}
                            onChange={(e) => {
                                if (!row.original.isEdit) {
                                    row.getToggleSelectedHandler()(e);
                                    setChecked({ index: row.original.individualId, value: e.target.checked });
                                }
                            }}
                        />
                    ),
                })
        }
        return baseColumns;
    }, [tab, checkedAll]);// eslint-disable-line react-hooks/exhaustive-deps

    const guestStartIndex = pagination.currentPage === 1
        ? 0
        : (pagination.currentPage - 1) * pagination.pageSize;

    const guestEndIndex = Math.min(guestStartIndex + pagination.pageSize, guestData.length);
    const data = tab === 1 ? shareholdersData : tab === 2 ? guestData.slice(guestStartIndex, guestEndIndex) : participantsData
    const table = useReactTable({
        data,
        columns,
        filterFns: {
            fuzzy: fuzzyFilter,
        },
        manualPagination: true,
        rowCount: pagination.totalCount,
        state: {
            columnFilters,
            globalFilter,
        },
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        globalFilterFn: multiFieldGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
    })
    useEffect(() => {
        if (tab === 3)
            getMeetingParticipant()
        if (tab === 1)
            getIndividualParticipant()
    }, [pagination.currentPage, pagination.pageSize, isActive, tab])// eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = (pageNumber: number) => {
        setPagination((prev) => ({ ...prev, currentPage: pageNumber }))
    }
    useEffect(() => {
        if (tab === 2) {
            const totalCount: number = guestData.length
            const pageSize: number = Math.ceil(totalCount / pagination?.pageSize)
            setPagination({
                currentPage: 1,
                pageSize: 10,
                totalCount: totalCount,
                nextPage: totalCount > 10 ? 2 : 0,
                prevPage: null,
                totalPages: pageSize
            })
        }
    }, [tab])// eslint-disable-line react-hooks/exhaustive-deps

    const updateParticipant = async () => {
        await Promise.all(updateParticipantList.map(async (data: any) => {
            try {
                setLoading(true)
                const {
                    data: { success, error },
                } = await updateMeetingParticipant({ type: data.value }, meetingId, data.participantId)
                if (success) {
                    setLoading(false)
                    TagManager.dataLayer({
                        dataLayer: {
                            event: GTMEvent.ParticipantUpdatedSuccessful,
                            action: 'normal',
                            metadata: {
                                company_id: companyId,
                                user_id: currentUser?.userId,
                                email: currentUser?.email,
                                participant_id: data.participantsId,
                                payload: data.value,
                                error: error[0]
                            },
                        },
                    })
                }
                else {
                    TagManager.dataLayer({
                        dataLayer: {
                            event: GTMEvent.ParticipantUpdateFailed,
                            action: 'normal',
                            metadata: {
                                company_id: companyId,
                                user_id: currentUser?.userId,
                                email: currentUser?.email,
                                participant_id: data.participantsId,
                                payload: data.value,
                                error: error[0]
                            },
                        },
                    })
                }
            } catch (err) {
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantUpdateFailed,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_id: data.participantsId,
                            payload: data.value,
                            error: err
                        },
                    },
                })
            }
        }))
        setUpdateParticipantList([])
        setIsActive(false)
    }
    const handleIndividualSubmit = async () => {
        if (individualsData.length === 0) {
            toast.error(formatMessage({ id: 'Please select one option.' }))
        }
        let updatedIndividualData: any
        if (individualsData.length) {
            updatedIndividualData = individualsData.map(individual => {
                const updatedItem = updateParticipantList1.find(
                    (list: any) => list.participantId === individual.individualId
                );

                return {
                    name: individual.name,
                    email: individual.email,
                    type: updatedItem ? updatedItem.value : individual.type, // Update type if match is found
                    isGuest: false,
                    stakeholderIndividualId: individual.individualId
                };
            });
        }

        const payload: any = {};
        payload['participants'] = updatedIndividualData

        try {
            setLoading(true)
            const {
                data: { success, error },
            } = await createParticipants(payload, meetingId, companyId)
            if (success) {
                toast.success(formatMessage({ id: 'Participants added successfully.' }))
                setIndividualsData([])
                setShareholdersData([])
                setUpdateParticipantList1([])
                setIsActive(false)
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantAddedSuccessful,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_details: payload,

                        },
                    },
                })
            }
            else {
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.ParticipantAddedFailed,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            participant_details: payload,
                            error: error[0]
                        },
                    },
                })
            }
        } catch (e) {
            TagManager.dataLayer({
                dataLayer: {
                    event: GTMEvent.ParticipantAddedFailed,
                    action: 'normal',
                    metadata: {
                        company_id: companyId,
                        user_id: currentUser?.userId,
                        email: currentUser?.email,
                        participant_details: payload,
                        error: e
                    },
                },
            })
        } finally { setLoading(false) }
    }
    useEffect(() => { getIndividualParticipant(); setTab(1); setIndividualsData([]); setCheckedAll(false) }, [isActive])// eslint-disable-line react-hooks/exhaustive-deps
    return <>
        <Modal
            show={isActive}
            onHide={() => {
                setIsActive(false)
            }}
            fullscreen
        >
            <Modal.Header closeButton>
                <div className="d-flex flex-column">
                    <h2>{formatMessage({ id: 'Add Participants' })}</h2>
                </div>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={userSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                validateOnMount
            >
                {(formik: any) => {
                    console.log(formik)
                    return (
                        <>
                            <Modal.Body className="container">
                                <div
                                    className='p-0'
                                    style={{
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none',
                                    }}
                                >
                                    <div
                                        className='d-flex gap-3 col-md-8 col-12'
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'nowrap',
                                            scrollbarWidth: 'none',
                                            msOverflowStyle: 'none',
                                        }}
                                    >
                                        {options.map((opt, index) => (
                                            <div
                                                key={index}
                                                className={
                                                    `col options-container p-4 align-content-center cursor-pointer` +
                                                    (tab === index + 1 ? ' selected-option' : '')
                                                }
                                                style={{ width: '200px', flex: '0 0 auto', flexWrap: 'nowrap' }}
                                                onClick={() => {
                                                    handleTabChange(index)
                                                }}
                                            >
                                                <div className='d-flex align-items-center gap-1'>
                                                    <h1 className='m-0'>{opt.title}</h1>
                                                </div>
                                                <div className="d-flex flex-wrap" style={{ whiteSpace: 'normal', }}><p className='mt-2'>{opt.subTitle}</p></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="mt-4">
                                    {meetingType === 'Virtual Meeting' ?
                                        <InfoCard2 title={formatMessage({ id: "How to Schedule Virtual Compliance Meetings?" })} desc={formatMessage({ id: `Schedule virtual compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding scheduling details, managing participants, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.` })} slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingVirtual} /> :
                                        <InfoCard2 title={formatMessage({ id: "How to Schedule Physical Compliance Meetings?" })} desc={formatMessage({ id: `Schedule physical compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding venue and scheduling details, inviting attendees, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.` })} slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingPhysical} />
                                    }
                                    <Form>
                                        {tab === 1 ?
                                            <>
                                                <div className="d-md-flex justify-content-between">
                                                    <div className="d-flex align-items-start">
                                                        <form className=' d-flex border align-items-center w-md-auto w-100 mb-3 rounded'>
                                                            <span className='svg-icon svg-icon-3 position-absolute ms-3'>
                                                                <svg
                                                                    width='24'
                                                                    height='24'
                                                                    viewBox='0 0 24 24'
                                                                    fill='none'
                                                                    xmlns='http://www.w3.org/2000/svg'
                                                                    className='mh-50px'
                                                                >
                                                                    <rect
                                                                        opacity='0.5'
                                                                        x='17.0365'
                                                                        y='15.1223'
                                                                        width='8.15546'
                                                                        height='2'
                                                                        rx='1'
                                                                        transform='rotate(45 17.0365 15.1223)'
                                                                        fill='currentColor'
                                                                    ></rect>
                                                                    <path
                                                                        d='M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z'
                                                                        fill='currentColor'
                                                                    ></path>
                                                                </svg>
                                                            </span>
                                                            <DebouncedInput
                                                                value={globalFilter ?? ''}
                                                                onChange={(value) => setGlobalFilter(String(value))}
                                                                className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400'
                                                                placeholder={formatMessage({ id: 'Search by name or email' })}
                                                            />
                                                        </form>
                                                    </div>
                                                </div>
                                                <div className=""><h5 className="text-end fs-bold">{participantData?.length + individualsData?.length} Participants Selected</h5></div>
                                            </> : tab === 2 ?
                                                <>
                                                    <div className="row d-flex align-items-center">
                                                        <div className='col-md-5 col-12'>
                                                            <TextInput
                                                                fieldType='text'
                                                                label={formatMessage({ id: 'Guest Name' })}
                                                                fieldName='guestName'
                                                                formik={formik}
                                                                placeholder={formatMessage({ id: 'Enter Name' })}
                                                                toolTipText={formatMessage({
                                                                    id: 'Add name of the guest being invited for the meeting.',
                                                                })}
                                                                isTooltipForModal={true}
                                                            />
                                                        </div>
                                                        <div className='col-md-5 col-12'>
                                                            <TextInput
                                                                fieldType='text'
                                                                label={formatMessage({ id: 'Guest Email' })}
                                                                fieldName='guestEmail'
                                                                formik={formik}
                                                                placeholder={formatMessage({ id: 'Enter Guest Email' })}
                                                                toolTipText={formatMessage({
                                                                    id: 'Add email address of the guest being invited for the meeting.',
                                                                })}
                                                                isTooltipForModal={true}
                                                            />
                                                        </div>
                                                        <div className='col-md-2 col-12 d-flex justify-content-center'>
                                                            <button className="btn btn-primary py-3 w-100"
                                                                disabled={!formik.isValid}
                                                                onClick={() => { handleGuestSubmit(formik.values, formik.resetForm) }}
                                                                type='button'

                                                            >{formatMessage({ id: 'Add' })}</button>
                                                        </div>
                                                    </div>
                                                </> :
                                                <></>
                                        }
                                        {!loading && (data?.length === 0 || table.getRowModel().rows.length === 0) ?
                                            <>
                                                <div className=''>
                                                    <NoDataPage width={'w-0'} />
                                                </div>
                                            </>
                                            :
                                            <Table className='w-100 '>
                                                <thead className='custom-thead border-bottom'>
                                                    {table.getHeaderGroups().map((headerGroup) => (
                                                        <tr
                                                            key={headerGroup.id}
                                                            className='font-size-12 font-weight-400 w-100 table-row border-dark-mode '
                                                        >
                                                            {headerGroup.headers.map((header) => (
                                                                <th key={header.id} colSpan={header.colSpan} className=' pb-6 pt-4'>
                                                                    {header.isPlaceholder ? null : (
                                                                        <div
                                                                            className={header.column.getCanSort() ? 'cursor-pointer select-none' : ''}
                                                                            onClick={header.column.getToggleSortingHandler()}
                                                                        >
                                                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                                                            {{
                                                                                asc: ' ▲',
                                                                                desc: ' ▼',
                                                                            }[header.column.getIsSorted() as string] ?? null}
                                                                        </div>
                                                                    )}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </thead>

                                                <tbody>
                                                    {isLoading ? (
                                                        <>
                                                            <SkeletonRow count={5} />
                                                        </>
                                                    ) : (
                                                        table.getRowModel().rows.map((row) => (
                                                            <tr key={row.id} className='border-bottom'>
                                                                {row.getVisibleCells().map((cell) => (
                                                                    <td key={cell.id} className='pt-4 border-0'>
                                                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </Table>}

                                        {!isLoading && data.length > 0 &&
                                            <div className='w-100 d-md-flex justify-content-between align-items-center px-0 mt-8'>
                                                <div className='d-flex gap-2 w-100 align-items-center justify-content-md-start justify-content-center mb-4'>
                                                    <select
                                                        aria-label='Default select example'
                                                        className={`p-4 py-3 w-80px border border-1 rounded-2 font-size-13 bg-white text-dark ${mode === 'dark' ? ' border-dark' : ''}`}
                                                        value={pagination.pageSize}
                                                        onChange={(e) => {
                                                            const newSize = Number(e.target.value)
                                                            setPagination((prev) => ({
                                                                ...prev,
                                                                pageSize: newSize,
                                                                pageIndex: 0, // Reset to first page when page size changes
                                                            }))
                                                        }}
                                                    >
                                                        {[10, 20, 50, 100].map((pageSize) => (
                                                            <option key={pageSize} value={pageSize}>
                                                                {pageSize}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    <span className='font-size-13 text-center text-md-start'>
                                                        {formatMessage({
                                                            id: `Showing ${pagination.currentPage === 1
                                                                ? 1
                                                                : (pagination.currentPage - 1) * pagination.pageSize + 1
                                                                } to ${pagination.totalCount > pagination.currentPage * pagination.pageSize ? pagination.currentPage * pagination.pageSize : (pagination.totalCount - pagination.currentPage * pagination.pageSize) + pagination.currentPage * pagination.pageSize} of ${pagination.totalCount} records`,
                                                        })}
                                                    </span>
                                                </div>

                                                <Pagination className='w-md-100 w-auto d-flex flex-md-end justify-content-center justify-content-md-end '>
                                                    <Pagination.First onClick={() => handlePageChange(1)} disabled={!pagination.prevPage}>
                                                        {'<<'}
                                                    </Pagination.First>

                                                    <Pagination.Prev
                                                        onClick={() => handlePageChange(pagination.currentPage - 1)}
                                                        disabled={!pagination.prevPage}
                                                    >
                                                        {'<'}
                                                    </Pagination.Prev>

                                                    {Array.from({ length: pagination.totalPages }, (_, i) => (
                                                        <Pagination.Item
                                                            key={i}
                                                            active={i === pagination.currentPage - 1}
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </Pagination.Item>
                                                    ))}

                                                    <Pagination.Next
                                                        onClick={() => handlePageChange(pagination.currentPage + 1)}
                                                        disabled={!pagination.nextPage}
                                                    >
                                                        {'>'}
                                                    </Pagination.Next>

                                                    <Pagination.Last
                                                        onClick={() => handlePageChange(pagination.totalPages)}
                                                        disabled={!pagination.nextPage}
                                                    >
                                                        {'>>'}
                                                    </Pagination.Last>
                                                </Pagination>
                                            </div>
                                        }
                                    </Form>
                                </div>
                            </Modal.Body>
                            <Modal.Footer className='p-md-0 px-0 container d-flex'>
                                <div className='d-flex my-md-4 mx-6 mx-md-0 my-0 mb-2 justify-content-md-end justify-content-center w-md-auto w-100 order-2 order-md-1 mb-2'>
                                    <button
                                        className='btn bg-light custom-button-property text-muted font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                                        style={{ padding: '15px 40px' }}
                                        type="button"
                                        onClick={() => {
                                            setIsActive(false)
                                            setGuestData([])
                                            setIndividualsData([])
                                            setShareholdersData([])
                                            setCheckedAll(false)
                                            setUpdateParticipantList([])
                                            setUpdateParticipantList1([])
                                        }}
                                    >
                                        <span className='indicator-label font-size-13 p-0'>
                                            {formatMessage({ id: 'Discard' })}
                                        </span>
                                    </button>
                                </div>
                                <div className='d-flex my-md-4  mx-6 mx-md-0 my-0 justify-content-md-end justify-content-center w-md-auto w-100 order-1 order-md-2 mb-2'>
                                    <button
                                        className='btn bg-primary custom-button-property text-white font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                                        style={{ padding: '15px 40px' }}
                                        type='button'
                                        disabled={loading}
                                        onClick={async () => {
                                            if (tab === 1)
                                                handleIndividualSubmit()
                                            else if (tab === 2)
                                                handleSubmit()
                                            else {
                                                await updateParticipant()
                                            }
                                        }
                                        }
                                    >
                                        <span className='indicator-label font-size-13 p-0'>
                                            {loading ? formatMessage({ id: 'Please wait ...' }) : formatMessage({ id: 'Save' })}
                                        </span>
                                    </button>
                                </div>

                            </Modal.Footer>
                        </>
                    )
                }
                }
            </Formik>
        </Modal >
        <DeleteParticipantConfirmationModal
            setDeleteShowModal={setShowCancelModal}
            showDeleteModal={showCancelModal}
            onDeleteSubmit={id !== '' ? removeParticipant : removeGuest}
            deleteLoading={cancelLoading}
        />
    </>
}

function DebouncedInput({
    value: initialValue,
    onChange,
    debounce = 500,
    ...props
}: {
    value: string | number
    onChange: (value: string | number) => void
    debounce?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value)
        }, debounce)

        return () => clearTimeout(timeout)
    }, [value, debounce, onChange])
    return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />
}